<!-- Prefix icon when enabled -->
<div *ngIf="phxShowPrefixIcon" class="phx-nav-card-prefix-icon-container">
  <i phx-icon [phxIcon]="phxPrefixIcon">
  </i>
</div>

<!-- Title and Description -->
<div class="phx-nav-card-content">
  <div class="phx-nav-card-title">
    <span>{{ phxTitle }}</span>
  </div>
  <div *ngIf="phxDescription" class="phx-nav-card-description">
    {{ phxDescription }}
  </div>
</div>

<!-- Suffix icon -->
<div class="phx-nav-card-suffix">
  <i phx-icon [size]="24" [phxIcon]="ChevronRightIcon" color="currentColor">
  </i>
</div>